import styled from "styled-components/macro";

export const CustomFieldContainer = styled.div`
  position: relative;

  .field-container {
    min-height: 40px;
    border-radius: 5px;
    background: var(--document-background);
    padding: 0px;
    border: 1px solid var(--grey-3);
    box-shadow: var(--tiny-drop-shadow);
    &:focus-within {
      border: 1px solid var(--primary-cta);
    }
  }

  .tiptap-field,
  .tip-tap-field-container {
    font-family: "Inter";
    font-size: 16px;
    div {
      background: transparent;
    }
    .ProseMirror {
      color: var(--grey-0);
    }
  }

  .custom-field-header {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    margin-bottom: 5px;
    .item-menu {
      width: 32px;
      height: 32px;
      .icon-button-wrapper {
        transform: scale(0.9);
      }
    }

    input {
      background: none;
      border: none;
      font-size: 16px;
      font-weight: 500;
      color: var(--grey-1);
      min-width: 90%;
    }

    .key {
      min-width: 100px;
    }
  }

  .hotdog-dots {
    visibility: hidden;
    svg circle {
      fill: var(--grey-1);
    }
  }

  &:hover {
    .hotdog-dots {
      visibility: visible;
    }
  }
  .blurred-icon {
    margin-top: 3px;
    opacity: 0.5;
    svg {
      path {
        fill: var(--grey-1);
      }
    }
  }

  .editor-options-container {
    position: relative;
    z-index: 1;
    float: right;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 10px;
    margin: 5px;
    &.flat {
      // this deserves an explanation.  It's needed to fix the stacking context
      // so that the menu is displayed above the next field's ai visibility button.
      // HERE BE DRAGONS.  I don't totally understand why this works.
      z-index: unset;
    }
    p {
      font-size: 14px;
      color: var(--grey-1);
    }
  }

  .field-hint-container {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    border-radius: 5px;
    border: 0px solid var(--grey-1);
    padding: 3px 10px 3px 8px;
    gap: 5px;
    color: var(--grey-1);
    box-shadow: var(--reorderable-list-drop-shadow);
    background-color: var(--menu-color);
    cursor: pointer;
    svg {
      path {
        fill: var(--grey-1);
      }
    }
  }

  .field-hints-container {
    display: flex;
    flex-direction: row;
    margin-right: 10px;
  }

  .ai-visibility-arrow {
    width: 15px;
    height: 15px;
  }

  .guidance-container {
    position: absolute;
    left: 8px;
    bottom: 52px;
    z-index: 100;
    width: 518px;

    padding: 15px;
    background-color: var(--menu-color);
    box-shadow: var(--default-drop-shadow);
    border-radius: 14px;

    form {
      display: flex;
      flex-direction: row;
      align-items: flex-end;
      gap: 8px;

      .input-container {
        display: flex;
        flex-direction: column;
        flex-grow: 1;
        gap: 16px;

        .guidance-header {
          color: var(--grey-0);
          font-weight: 500;
        }

        textarea {
          min-height: 24px !important;
          max-height: 100px;
          border: none;
          margin: unset;
          padding: 0px;
          resize: none;
          background-color: transparent !important;
          font-size: 16px;
        }
      }
    }

    .go-button-container {
      display: flex;
      align-items: center;
      gap: 10px;
      width: 105px;
      flex-shrink: 0;
      border-radius: 10px !important;
      padding: 8px 12px !important;
      margin-top: 0px !important;
      height: 37px;

      .keyboard-shortcut {
        border: 2px solid rgba(255, 255, 255, 0.4);
        border-radius: 5px;
      }

      .keyboard-shortcut-container {
        display: flex;
        align-items: center;
        gap: 3px;
        svg {
          path {
            fill: var(--cta-text-color) !important;
          }
        }
      }
    }
  }
`;

export const CustomFieldActionMenuContainer = styled.div`
  position: relative;

  a.hotdog-dots {
    display: flex;
    align-items: center;
    .icon-wrapper {
      &:hover {
        background-color: var(--menu-color-hover);
      }
      svg {
        circle {
          fill: var(--grey-1);
        }
      }
    }
  }

  .custom-field-action-menu {
    position: absolute;
    top: 46px;
    z-index: 100;
    width: 250px;

    &.visible {
      visibility: visible;
    }

    &.anchor-right {
      right: 14px;
    }

    &.anchor-left {
      left: 14px;
    }

    .custom-field-action-menu__inner {
      background-color: var(--menu-color);
      width: 100%;
      height: 100%;
      box-shadow: var(--default-drop-shadow);
      border-radius: 14px;

      .actions {
        padding: 4px;
        .delete {
          &:hover {
            background-color: var(--danger-color-hover);
          }
          &:active {
            background-color: var(--danger-color-active);
          }
        }
      }
    }
    .menu-item {
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      align-items: center;
      padding: 10px 12px 10px 8px;
      border-radius: 10px !important;
      cursor: pointer;
      &.always {
        pointer-events: none;
        opacity: 0.5;
        cursor: default;
      }

      .label {
        font-size: 16px;
        font-weight: 500;
        color: var(--grey-0);
      }
      .description {
        font-size: 14px;
        font-weight: 400;
        color: var(--grey-1);
        margin-top: 2px;
      }
      svg {
        height: 24px;
        width: 24px;
        path {
          fill: var(--grey-0) !important;
          stroke: none;
        }
      }
      &:hover {
        background-color: var(--menu-color-hover);
      }
      &:active {
        background-color: var(--menu-color-active);
      }
      svg {
        max-height: 24px !important;
        path {
          stroke: none;
        }
      }
      &.delete {
        .label {
          color: var(--danger-color);
        }
        svg {
          path {
            fill: var(--danger-color) !important;
            stroke: none;
          }
        }
      }
      &:first-child {
        border-top-left-radius: 20px;
        border-top-right-radius: 20px;
      }

      &:last-child {
        border-bottom-left-radius: 20px;
        border-bottom-right-radius: 20px;
      }
    }

    .label {
      font-size: 16px;

      white-space: nowrap;
      color: var(--grey-0);
      font-weight: 500;
    }

    .icon {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 24px;
      height: 24px;
      margin-right: 5px;
    }
  }

  .delete-message-container {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    gap: 15px;
    padding: 20px;
    width: 200px;
    font-size: 16px;
    line-height: 1.3;
    color: var(--grey-0);
    font-weight: 500;
    background-color: var(--menu-color);
    border-radius: 15px;

    .delete-heading {
      font-weight: bold;
    }

    .delete-message {
      span {
        font-style: italic;
      }
    }

    .confirm {
      color: var(--danger-color);
      font-weight: 500;
      cursor: pointer;
    }
  }
`;
